export default () => ({
    open: false,

    away: {
        ['@click.away']() {
            this.off()
        },
    },

    mouseleave: {
        ['@mouseleave']() {
            this.off()
        },
    },

    on() { this.open = true },
    off() { this.open = false },
    isOpen() { return this.open === true },
    toggle() { this.open = !this.open }
})